// import constant
import {
    SET_PAYPAL_DETAIL,
    SET_PAYPAL_FORM
} from '../constant';

const initialState = {
    formType: '',
    formDisable: true,
    editRecord: {},
    result: []
};

const paypalDetail = (state = initialState, action) => {
    switch (action.type) {
        case SET_PAYPAL_DETAIL:
            return {
                ...state,
                ...action.data
            };
        case SET_PAYPAL_FORM:
            return {
                ...state,
                ...action.data
            };

        default:
            return state;
    }

}

export default paypalDetail;